<div class="pest-models-page flex flex-col gap-4 pt-4">
  <div class="card flex flex-col gap-3 p-4">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div class="flex flex-col gap-2">
        <div class="flex flex-wrap items-center gap-2">
          <mat-form-field appearance="outline" class="min-w-[200px]">
            <mat-label>{{ 'PEST_MODELS.FARM_LABEL' | translate }}</mat-label>
            <mat-select
              [disabled]="fincasLoading || !fincas.length"
              [value]="fincaId"
              (selectionChange)="onFincaChange($event.value)"
            >
              <mat-option *ngIf="fincasLoading" [value]="null">
                {{ 'PEST_MODELS.FARMS_LOADING' | translate }}
              </mat-option>
              <mat-option
                *ngFor="let finca of fincas"
                [value]="finca.idFinca"
              >
                {{ finca.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="text-xs uppercase tracking-wide text-slate-500">
            {{ 'PEST_MODELS.FARM_ID' | translate: { id: fincaId || '-' } }}
          </div>
        </div>
        <div class="text-xl font-semibold text-slate-900">
          {{ catalog?.finca?.name || ('PEST_MODELS.TITLE' | translate) }}
        </div>
        <div class="text-sm text-slate-500" *ngIf="catalog?.context">
          {{
            catalog?.context?.hasCropContext
              ? ('PEST_MODELS.CROP_CONTEXT' | translate)
              : ('PEST_MODELS.NO_CROP_CONTEXT' | translate)
          }}
        </div>
      </div>

      <div class="controls flex flex-wrap items-center gap-2">
        <mat-form-field appearance="outline" class="w-28">
          <mat-label>{{ 'PEST_MODELS.LIMIT_LABEL' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="1"
            [(ngModel)]="limit"
            (ngModelChange)="refresh()"
          />
        </mat-form-field>
        <mat-checkbox
          [checked]="includeState"
          (change)="includeState = $event.checked; refresh()"
          >{{ 'PEST_MODELS.STATE_LABEL' | translate }}</mat-checkbox
        >
        <mat-checkbox
          [checked]="includeInsights"
          (change)="includeInsights = $event.checked; refresh()"
          >{{ 'PEST_MODELS.INSIGHTS_LABEL' | translate }}</mat-checkbox
        >
        <mat-checkbox
          [checked]="onlyActive"
          (change)="onlyActive = $event.checked; refresh()"
          >{{ 'PEST_MODELS.ONLY_ACTIVE' | translate }}</mat-checkbox
        >
        <mat-checkbox
          *ngIf="roleId === 1"
          [checked]="debugEnabled"
          (change)="onDebugToggle($event.checked)"
          >Debug</mat-checkbox
        >
        <button
          mat-flat-button
          color="primary"
          class="refresh-btn"
          (click)="refresh()"
        >
          {{ 'PEST_MODELS.REFRESH' | translate }}
        </button>
      </div>
    </div>
    <div class="text-xs text-slate-500" *ngIf="catalog?.catalogVersion">
      {{ 'PEST_MODELS.CATALOG_VERSION' | translate: { version: catalog?.catalogVersion } }}
    </div>
  </div>

  <div class="card flex flex-col gap-3 p-4">
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="text-sm font-semibold text-slate-900">
        {{ 'PEST_MODELS.CONFIG_TITLE' | translate }}
      </div>
      <button
        mat-flat-button
        color="primary"
        (click)="saveMagnitudeConfig()"
        [disabled]="!selectedModuleId || configSaving"
      >
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
    <div class="text-sm text-slate-500" *ngIf="configLoading">
      {{ 'PEST_MODELS.CONFIG_LOADING' | translate }}
    </div>
    <div class="text-sm text-slate-500" *ngIf="sensorsLoading">
      {{ 'PEST_MODELS.SENSORS_LOADING' | translate }}
    </div>
    <div class="text-sm text-slate-500" *ngIf="modules.length === 0 && !modulesLoading">
      {{ 'PEST_MODELS.NO_MODULES' | translate }}
    </div>
    <div class="text-sm text-slate-500" *ngIf="modulesLoading">
      {{ 'PEST_MODELS.MODULES_LOADING' | translate }}
    </div>

    <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
      <div class="flex flex-col gap-2">
        <div class="text-xs uppercase tracking-wide text-slate-500">
          {{ 'PEST_MODELS.MAGNITUDE.TEMPERATURE' | translate }}
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'PEST_MODELS.SOURCE_LABEL' | translate }}</mat-label>
          <mat-select
            [(ngModel)]="magnitudeConfig.temperatureSource"
            (selectionChange)="onSourceChange('temperature')"
          >
            <mat-option
              *ngFor="let source of sourceOptionsByMagnitude.temperature; trackBy: trackByOptionValue"
              [value]="source.value"
              [disabled]="source.disabled"
            >
              {{ source.labelKey | translate }}
              <span
                class="text-xs text-slate-500"
                *ngIf="source.disabled"
              >
                ({{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }})
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSensorInput.temperature"
        >
          <mat-label>{{ 'PEST_MODELS.SENSOR_LABEL' | translate }}</mat-label>
          <mat-select [(ngModel)]="magnitudeConfig.temperatureSensorId">
            <mat-option
              *ngFor="let option of sensorOptionsByMagnitude.temperature; trackBy: trackBySensorId"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-option>
            <mat-option
              *ngIf="sensorOptionsByMagnitude.temperature.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.temperature"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="aemetProvinceSelection.temperature"
            (selectionChange)="onAemetProvinceChange('temperature', $event.value)"
          >
            <mat-option
              *ngFor="let province of aemetProvinces; trackBy: trackByString"
              [value]="province"
            >
              {{ province }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.temperature"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="siarProvinceSelection.temperature"
            (selectionChange)="onSiarProvinceChange('temperature', $event.value)"
          >
            <mat-option
              *ngFor="let province of siarProvinces; trackBy: trackBySiarProvince"
              [value]="province.id"
            >
              {{ province.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.temperature"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.temperatureAemetStationId"
            (selectionChange)="onAemetStationChange('temperature', $event.value)"
          >
            <mat-option
              *ngFor="let station of aemetStationsByMagnitude.temperature; trackBy: trackByAemetStation"
              [value]="station.idema"
            >
              {{ formatAemetStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="aemetStationsByMagnitude.temperature.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.temperature"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.temperatureSiarStationId"
            (selectionChange)="onSiarStationChange('temperature', $event.value)"
          >
            <mat-option
              *ngFor="let station of siarStationsByMagnitude.temperature; trackBy: trackBySiarStation"
              [value]="station.id"
            >
              {{ formatSiarStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="siarStationsByMagnitude.temperature.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-xs uppercase tracking-wide text-slate-500">
          {{ 'PEST_MODELS.MAGNITUDE.HUMIDITY' | translate }}
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'PEST_MODELS.SOURCE_LABEL' | translate }}</mat-label>
          <mat-select
            [(ngModel)]="magnitudeConfig.humiditySource"
            (selectionChange)="onSourceChange('humidity')"
          >
            <mat-option
              *ngFor="let source of sourceOptionsByMagnitude.humidity; trackBy: trackByOptionValue"
              [value]="source.value"
              [disabled]="source.disabled"
            >
              {{ source.labelKey | translate }}
              <span
                class="text-xs text-slate-500"
                *ngIf="source.disabled"
              >
                ({{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }})
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSensorInput.humidity"
        >
          <mat-label>{{ 'PEST_MODELS.SENSOR_LABEL' | translate }}</mat-label>
          <mat-select [(ngModel)]="magnitudeConfig.humiditySensorId">
            <mat-option
              *ngFor="let option of sensorOptionsByMagnitude.humidity; trackBy: trackBySensorId"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-option>
            <mat-option
              *ngIf="sensorOptionsByMagnitude.humidity.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button
          mat-stroked-button
          color="primary"
          class="self-start"
          *ngIf="canSyncTempHumidity()"
          (click)="syncTempHumiditySensor()"
        >
          {{ 'PEST_MODELS.USE_SAME_SENSOR' | translate }}
        </button>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.humidity"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="aemetProvinceSelection.humidity"
            (selectionChange)="onAemetProvinceChange('humidity', $event.value)"
          >
            <mat-option
              *ngFor="let province of aemetProvinces; trackBy: trackByString"
              [value]="province"
            >
              {{ province }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.humidity"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="siarProvinceSelection.humidity"
            (selectionChange)="onSiarProvinceChange('humidity', $event.value)"
          >
            <mat-option
              *ngFor="let province of siarProvinces; trackBy: trackBySiarProvince"
              [value]="province.id"
            >
              {{ province.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.humidity"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.humidityAemetStationId"
            (selectionChange)="onAemetStationChange('humidity', $event.value)"
          >
            <mat-option
              *ngFor="let station of aemetStationsByMagnitude.humidity; trackBy: trackByAemetStation"
              [value]="station.idema"
            >
              {{ formatAemetStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="aemetStationsByMagnitude.humidity.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.humidity"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.humiditySiarStationId"
            (selectionChange)="onSiarStationChange('humidity', $event.value)"
          >
            <mat-option
              *ngFor="let station of siarStationsByMagnitude.humidity; trackBy: trackBySiarStation"
              [value]="station.id"
            >
              {{ formatSiarStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="siarStationsByMagnitude.humidity.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-xs uppercase tracking-wide text-slate-500">
          {{ 'PEST_MODELS.MAGNITUDE.PRECIPITATION' | translate }}
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'PEST_MODELS.SOURCE_LABEL' | translate }}</mat-label>
          <mat-select
            [(ngModel)]="magnitudeConfig.precipitationSource"
            (selectionChange)="onSourceChange('precipitation')"
          >
            <mat-option
              *ngFor="let source of sourceOptionsByMagnitude.precipitation; trackBy: trackByOptionValue"
              [value]="source.value"
              [disabled]="source.disabled"
            >
              {{ source.labelKey | translate }}
              <span
                class="text-xs text-slate-500"
                *ngIf="source.disabled"
              >
                ({{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }})
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSensorInput.precipitation"
        >
          <mat-label>{{ 'PEST_MODELS.SENSOR_LABEL' | translate }}</mat-label>
          <mat-select [(ngModel)]="magnitudeConfig.precipitationSensorId">
            <mat-option
              *ngFor="let option of sensorOptionsByMagnitude.precipitation; trackBy: trackBySensorId"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-option>
            <mat-option
              *ngIf="sensorOptionsByMagnitude.precipitation.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.precipitation"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="aemetProvinceSelection.precipitation"
            (selectionChange)="onAemetProvinceChange('precipitation', $event.value)"
          >
            <mat-option
              *ngFor="let province of aemetProvinces; trackBy: trackByString"
              [value]="province"
            >
              {{ province }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.precipitation"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="siarProvinceSelection.precipitation"
            (selectionChange)="onSiarProvinceChange('precipitation', $event.value)"
          >
            <mat-option
              *ngFor="let province of siarProvinces; trackBy: trackBySiarProvince"
              [value]="province.id"
            >
              {{ province.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.precipitation"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.precipitationAemetStationId"
            (selectionChange)="onAemetStationChange('precipitation', $event.value)"
          >
            <mat-option
              *ngFor="let station of aemetStationsByMagnitude.precipitation; trackBy: trackByAemetStation"
              [value]="station.idema"
            >
              {{ formatAemetStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="aemetStationsByMagnitude.precipitation.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.precipitation"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.precipitationSiarStationId"
            (selectionChange)="onSiarStationChange('precipitation', $event.value)"
          >
            <mat-option
              *ngFor="let station of siarStationsByMagnitude.precipitation; trackBy: trackBySiarStation"
              [value]="station.id"
            >
              {{ formatSiarStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="siarStationsByMagnitude.precipitation.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-xs uppercase tracking-wide text-slate-500">
          {{ 'PEST_MODELS.MAGNITUDE.WIND' | translate }}
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ 'PEST_MODELS.SOURCE_LABEL' | translate }}</mat-label>
          <mat-select
            [(ngModel)]="magnitudeConfig.windSource"
            (selectionChange)="onSourceChange('wind')"
          >
            <mat-option
              *ngFor="let source of sourceOptionsByMagnitude.wind; trackBy: trackByOptionValue"
              [value]="source.value"
              [disabled]="source.disabled"
            >
              {{ source.labelKey | translate }}
              <span
                class="text-xs text-slate-500"
                *ngIf="source.disabled"
              >
                ({{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }})
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSensorInput.wind"
        >
          <mat-label>{{ 'PEST_MODELS.SENSOR_LABEL' | translate }}</mat-label>
          <mat-select [(ngModel)]="magnitudeConfig.windSensorId">
            <mat-option
              *ngFor="let option of sensorOptionsByMagnitude.wind; trackBy: trackBySensorId"
              [value]="option.id"
            >
              {{ option.label }}
            </mat-option>
            <mat-option
              *ngIf="sensorOptionsByMagnitude.wind.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_SENSOR_COMPATIBLE' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.wind"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="aemetProvinceSelection.wind"
            (selectionChange)="onAemetProvinceChange('wind', $event.value)"
          >
            <mat-option
              *ngFor="let province of aemetProvinces; trackBy: trackByString"
              [value]="province"
            >
              {{ province }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.wind"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_PROVINCE' | translate }}</mat-label>
          <mat-select
            [value]="siarProvinceSelection.wind"
            (selectionChange)="onSiarProvinceChange('wind', $event.value)"
          >
            <mat-option
              *ngFor="let province of siarProvinces; trackBy: trackBySiarProvince"
              [value]="province.id"
            >
              {{ province.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showAemetInput.wind"
        >
          <mat-label>{{ 'PEST_MODELS.AEMET_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.windAemetStationId"
            (selectionChange)="onAemetStationChange('wind', $event.value)"
          >
            <mat-option
              *ngFor="let station of aemetStationsByMagnitude.wind; trackBy: trackByAemetStation"
              [value]="station.idema"
            >
              {{ formatAemetStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="aemetStationsByMagnitude.wind.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="w-full"
          *ngIf="showSiarInput.wind"
        >
          <mat-label>{{ 'PEST_MODELS.SIAR_STATION' | translate }}</mat-label>
          <mat-select
            [value]="magnitudeConfig.windSiarStationId"
            (selectionChange)="onSiarStationChange('wind', $event.value)"
          >
            <mat-option
              *ngFor="let station of siarStationsByMagnitude.wind; trackBy: trackBySiarStation"
              [value]="station.id"
            >
              {{ formatSiarStationLabel(station) }}
            </mat-option>
            <mat-option
              *ngIf="siarStationsByMagnitude.wind.length === 0"
              [disabled]="true"
            >
              {{ 'PEST_MODELS.NO_STATIONS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="alert alert-warning" *ngIf="error">{{ error }}</div>
  <div class="text-sm text-slate-500" *ngIf="loading">
    {{ 'PEST_MODELS.LOADING' | translate }}
  </div>

  <div
    class="muted text-sm"
    *ngIf="!loading && !models.length && !error"
  >
    {{ 'PEST_MODELS.NO_MODELS' | translate }}
  </div>

  <div class="models-grid grid gap-3">
    <div
      class="card model-card flex flex-col gap-3 p-4"
      *ngFor="let model of models; trackBy: trackByModelCode"
    >
      <div class="flex flex-wrap items-start justify-between gap-3">
        <div class="flex flex-col gap-1">
          <div class="text-xs font-semibold text-slate-500">Modelo</div>
          <div class="text-xs uppercase tracking-wide text-slate-500">
            {{ model.code }}
          </div>
          <div class="text-lg font-semibold text-slate-900">
            {{ getCatalogName(model) }}
          </div>
          <div class="text-sm text-slate-500" *ngIf="getCatalogDescription(model)">
            {{ getCatalogDescription(model) }}
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <span class="chip" *ngIf="model.type">
            {{ 'PEST_MODELS.TYPE_LABEL' | translate }}
            {{ getCatalogType(model.type) }}
          </span>
          <span class="chip" *ngIf="model.version">v{{ model.version }}</span>
          <span class="chip subtle" *ngIf="model.status">
            {{ getCatalogStatus(model.status) }}
          </span>
        </div>
      </div>

      <div class="meta grid gap-2 md:grid-cols-2 xl:grid-cols-3">
        <div class="meta-item" *ngIf="model.frequency">
          <div class="meta-label">{{ 'PEST_MODELS.FREQUENCY' | translate }}</div>
          <div class="meta-value">{{ getFrequencyLabel(model.frequency) }}</div>
        </div>
        <div class="meta-item" *ngIf="model.idealResolution">
          <div class="meta-label">{{ 'PEST_MODELS.IDEAL_RESOLUTION' | translate }}</div>
          <div class="meta-value">{{ getResolutionLabel(model.idealResolution) }}</div>
        </div>
        <div class="meta-item" *ngIf="model.dataWindowDays">
          <div class="meta-label">{{ 'PEST_MODELS.DATA_WINDOW' | translate }}</div>
          <div class="meta-value">
            {{ 'PEST_MODELS.DAYS_COUNT' | translate: { count: model.dataWindowDays } }}
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-xs font-semibold text-slate-500">Suscripción</div>
        <div class="flex flex-wrap items-center gap-2">
          <span
            class="chip success"
            *ngIf="model.hasAnyActiveSubscriptions"
            matTooltip="{{ 'PEST_MODELS.SUBSCRIPTION_ACTIVE_HINT' | translate }}"
          >
            {{ 'PEST_MODELS.SUBSCRIPTION_ACTIVE' | translate }}
          </span>
          <span
            class="chip info"
            *ngIf="model.userSubscribed"
            matTooltip="{{ 'PEST_MODELS.SUBSCRIPTION_ME_HINT' | translate }}"
          >
            {{ 'PEST_MODELS.SUBSCRIPTION_ME' | translate }}
          </span>
          <span class="chip subtle" *ngIf="!model.userSubscribed">
            No suscrito
          </span>
          <span
            class="chip subtle"
            *ngIf="model.userSubscription"
          >
            {{ 'PEST_MODELS.SUBSCRIPTION_PREF' | translate }}:
            {{ getSubscriptionLevelLabel(model) }}
          </span>
        </div>
        <div class="flex flex-wrap items-center gap-2">
        <button
          mat-flat-button
          color="primary"
          *ngIf="!model.userSubscribed"
          (click)="openSubscribeDialog(model)"
        >
          {{ 'PEST_MODELS.SUBSCRIBE' | translate }}
        </button>
        <ng-container *ngIf="model.userSubscribed">
          <button
            mat-stroked-button
            color="primary"
            (click)="openSubscribeDialog(model)"
          >
            {{ 'PEST_MODELS.EDIT_SUBSCRIPTION' | translate }}
          </button>
          <button
            mat-stroked-button
            color="warn"
            (click)="unsubscribe(model)"
          >
            {{ 'PEST_MODELS.UNSUBSCRIBE' | translate }}
          </button>
        </ng-container>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <div class="text-xs font-semibold text-slate-500">Motor</div>

      <ng-container *ngIf="includeState">
        <div
          class="state-block rounded-lg bg-slate-50 p-3"
          *ngIf="model.fincaModel; else noState"
        >
          <div class="text-sm font-semibold text-slate-900 mb-2">
            {{ 'PEST_MODELS.STATE_LABEL' | translate }}
          </div>
          <div class="text-sm text-slate-700 mb-2">
            {{ getAgronomicStatusKey(model.fincaModel) | translate }}
          </div>

          <!-- 1) Estado principal -->
          <div class="flex flex-wrap items-center gap-2">
            <span [class]="modelStatusClass(model.fincaModel)">
              {{ model.fincaModel?.status || ('PEST_MODELS.NO_STATE_SHORT' | translate) }}
            </span>
            <span
              class="status-chip muted"
              *ngIf="shouldShowPausedAfterSubscription(model)"
            >
              {{ 'PEST_MODELS.PAUSED_NO_SUBS' | translate }}
            </span>
            <span class="status-chip muted">
              {{ 'PEST_MODELS.LAST_RUN_STATUS' | translate }}:
              {{ model.fincaModel?.lastRunStatus || '-' }}
            </span>
          </div>

          <div
            class="alert alert-warning mt-3"
            *ngIf="isSuspendedState(model.fincaModel)"
          >
            <div class="font-semibold">{{ 'PEST_MODELS.REASON' | translate }}</div>
            <div class="text-sm">
              {{ extractSuspensionReason(model.fincaModel) || '-' }}
            </div>
          </div>

          <div class="text-sm text-slate-500 mt-2" *ngIf="isInitialState(model)">
            {{ 'PEST_MODELS.INITIAL_STATE' | translate }}
          </div>
          <div class="text-xs text-slate-500 mt-1" *ngIf="shouldRenderDebug() && shouldShowDebugMainCause(model)">
            Bloqueo principal: {{ getDebugMainCauseLabel(model) }}
          </div>

          <!-- 2) Información operativa -->
          <div class="state-meta mt-3" *ngIf="hasExecution(model.fincaModel) && model.userSubscribed === true">
            <div class="meta-label">{{ 'PEST_MODELS.LAST_RUN_AT' | translate }}</div>
            <div class="meta-value">{{ formatDate(model.fincaModel?.lastRunAt) }}</div>
          </div>
          <div class="state-meta" *ngIf="hasExecution(model.fincaModel) && model.userSubscribed === true">
            <div class="meta-label">{{ 'PEST_MODELS.NEXT_RUN_AT' | translate }}</div>
            <div class="meta-value">{{ formatDate(model.fincaModel?.nextRunAt) }}</div>
          </div>
          <div class="state-meta" *ngIf="hasExecution(model.fincaModel) && model.userSubscribed === true">
            <div class="meta-label">{{ 'PEST_MODELS.LAST_WINDOW' | translate }}</div>
            <div class="meta-value">
              {{ formatWindowSummary(model.fincaModel?.lastComputedWindow) }}
            </div>
          </div>

          <!-- 3) Resumen técnico corto -->
          <div class="state-meta" *ngIf="getDdAccumulatedSummary(model) as ddAccumulated">
            <div class="meta-label">DD</div>
            <div class="meta-value">{{ ddAccumulated }}</div>
          </div>

          <!-- 4) Bloque técnico plegable -->
          <div class="payload-debug mt-3">
            <button
              mat-stroked-button
              color="primary"
              (click)="togglePayload(technicalToggleKey(model.code))"
            >
              {{
                isPayloadOpen(technicalToggleKey(model.code))
                  ? ('PEST_MODELS.HIDE_PAYLOAD' | translate)
                  : ('PEST_MODELS.SHOW_PAYLOAD' | translate)
              }}
            </button>
            <div *ngIf="isPayloadOpen(technicalToggleKey(model.code))">
              <div class="text-xs text-slate-500 mt-2" *ngIf="shouldRenderDebug()">
                <div class="font-semibold">Motor</div>
                <div>
                  suscripción:
                  {{ getDebugMotorSubscription(model) }}
                </div>
                <div>
                  motivo:
                  {{ getDebugMotorReason(model) }}
                </div>
                <div>
                  aplicabilidad:
                  {{ getDebugMotorApplicability(model) }}
                </div>
                <div class="font-semibold mt-1">Ejecución</div>
                <div>
                  estado:
                  {{ getDebugExecutionStatus(model) }}
                </div>
                <div>
                  causa:
                  {{ getDebugExecutionCause(model) }}
                </div>
                <div>
                  plan:
                  {{ getDebugExecutionPlan(model) }}
                </div>
                <div class="font-semibold mt-1">Datos</div>
                <div *ngFor="let item of getDebugRequiredMagnitudeStatuses(model)">
                  {{ item.magnitude }}: {{ item.state }}
                </div>
              </div>

              <div class="state-meta mt-3">
                <div class="meta-label">{{ 'PEST_MODELS.QUALITY' | translate }}</div>
                <div class="meta-value">
                  {{ formatQuality(model.fincaModel?.lastQuality) }}
                </div>
              </div>

              <div class="state-meta mt-3">
                <div class="meta-label">{{ 'PEST_MODELS.CONTEXT' | translate }}</div>
                <pre class="code-block" *ngIf="hasContextDetails(model.fincaModel?.lastContext); else contextAsText">
{{ model.fincaModel?.lastContext | json }}
                </pre>
                <ng-template #contextAsText>
                  <div class="meta-value">
                    {{ formatContext(model.fincaModel?.lastContext) || '-' }}
                  </div>
                </ng-template>
              </div>

              <div class="state-meta mt-3" *ngIf="model.userSubscribed === true">
                <div class="meta-label">{{ 'PEST_MODELS.LAST_WINDOW' | translate }}</div>
                <pre class="code-block" *ngIf="model.fincaModel?.lastComputedWindow">
{{ model.fincaModel?.lastComputedWindow | json }}
                </pre>
                <div class="meta-value" *ngIf="!model.fincaModel?.lastComputedWindow">
                  -
                </div>
              </div>

              <div class="state-meta mt-3" *ngIf="model.fincaModel?.lastRunSummary">
                <div class="meta-label">{{ 'PEST_MODELS.REASON' | translate }}</div>
                <div class="meta-value">{{ model.fincaModel?.lastRunSummary }}</div>
              </div>

              <div class="state-meta mt-3" *ngIf="model.fincaModel?.statePayload">
                <div class="meta-label">Payload</div>
                <pre class="code-block">
{{ model.fincaModel?.statePayload | json }}
                </pre>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noState>
          <div class="text-sm text-slate-500 mt-2">
            {{ 'PEST_MODELS.NO_STATE' | translate }}
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="includeInsights && model.insights?.length && model.userSubscribed === true">
        <div class="insights-block">
          <div class="block-title">{{ 'PEST_MODELS.INSIGHTS_TITLE' | translate }}</div>
          <div class="insights-list flex flex-col gap-2">
            <div class="insight-row" *ngFor="let insight of safeInsights(model.insights); trackBy: trackByInsightKey; let i = index">
              <div class="insight-header">
                <span class="chip" [ngClass]="['sev-' + (insight.severity || 'info').toLowerCase()]">
                  {{ insight.severity || 'info' }}
                </span>
                <span class="fingerprint">#{{ insight.fingerprint }}</span>
              </div>
              <div class="insight-body">
                <div class="text-sm font-medium text-slate-900">
                  {{ insight.message || insight.insightKey }}
                </div>
                <div class="text-xs text-slate-500">
                  {{ 'PEST_MODELS.VALIDITY' | translate }}:
                  {{ insight.validFrom || '-' }} / {{ insight.validTo || '-' }}
                  <span *ngIf="insight.confidence">
                    · {{ 'PEST_MODELS.CONFIDENCE' | translate }}: {{ insight.confidence }}
                  </span>
                </div>
                <div class="text-xs text-slate-600" *ngIf="insight.explanation">
                  {{ insight.explanation }}
                </div>
                <button
                  mat-stroked-button
                  color="primary"
                  class="mt-2"
                  *ngIf="insight.context"
                  (click)="togglePayload(insightContextToggleKey(model.code, insight, i))"
                >
                  {{
                    isPayloadOpen(insightContextToggleKey(model.code, insight, i))
                      ? ('PEST_MODELS.HIDE_CONTEXT' | translate)
                      : ('PEST_MODELS.SHOW_CONTEXT' | translate)
                  }}
                </button>
                <pre
                  class="code-block"
                  *ngIf="insight.context && isPayloadOpen(insightContextToggleKey(model.code, insight, i))"
                >
{{ insight.context | json }}
                </pre>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      </div>
    </div>
  </div>

  <ng-template #subscriptionDialog>
    <h2 mat-dialog-title>{{ 'PEST_MODELS.SUBSCRIPTION_TITLE' | translate }}</h2>
    <mat-dialog-content>
      <div class="text-sm text-slate-500 mb-3" *ngIf="subscriptionModel">
        {{ getCatalogName(subscriptionModel) }}
      </div>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ 'PEST_MODELS.SUBSCRIPTION_LEVEL_LABEL' | translate }}</mat-label>
        <mat-select [(ngModel)]="subscriptionLevel">
          <mat-option
            *ngFor="let option of subscriptionLevels; trackBy: trackBySubscriptionValue"
            [value]="option.value"
          >
            {{ option.labelKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="closeSubscriptionDialog()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" (click)="confirmSubscription()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
